import API from './api';

export default class ResultsSection extends API { }
